// extracted by mini-css-extract-plugin
module.exports = {"link":"ButtonLink_link__ub4oo"};